import type {
  AddImportWidgetModuleViaIFrameFaults,
  UnexpectedFault,
  WidgetGenericFault,
} from "@skbkontur/loader-builder";
import type { PlatformTypesConstraint } from "./index.js";

export const internalFieldSymbolId = "internalField";
export const internalFieldSymbol: unique symbol = Symbol(internalFieldSymbolId);
export type InternalFieldSymbol = typeof internalFieldSymbol;

export type Externals = {
  [key: string]: {
    value: unknown;
    version: string;
  };
};
export type AllNpmLoaderDependencies<TPlatformTypes extends PlatformTypesConstraint> =
  TPlatformTypes["ImportDependencies"] & {
    readonly [internalFieldSymbol]: {
      readonly externals: Externals;
    };
  };

export type IframeConfiguratorFaults = UnexpectedFault;
export type ConfigureIframeFaults<TPlatformTypes extends PlatformTypesConstraint> =
  | IframeConfiguratorFaults
  | TPlatformTypes["JsLoaderImportsFaults"];
export type ConfigureIframeDisposeFaults = never;

export type JsLoaderImportFaults<TPlatformTypes extends PlatformTypesConstraint> = AddImportWidgetModuleViaIFrameFaults<
  TPlatformTypes["WidgetImportFaults"],
  ConfigureIframeFaults<TPlatformTypes>,
  ConfigureIframeDisposeFaults
>;

export type ProvideExternalsFault = WidgetGenericFault<"provide-externals">;
export let externals: Externals = {};
// TODO: Do not use _setDependencies. This function for internal using
export function _setDependencies(dependencies: Externals): void {
  externals = dependencies;
}
